import { WidgetButtonProps } from 'jamespot-user-api';
import React from 'react';
import { useIntl } from 'react-intl';

import styled, { css } from 'styled-components';
import { colorTransparency } from 'utils/utils.color';

type CSSButtonProps = {
    color: string | undefined;
    size: 'sm' | 'md' | 'lg' | undefined;
    borderRadius: string | undefined;
    variant: string | undefined;
    backgroundColor: string | undefined;
};

const CSSStyle = css<CSSButtonProps>`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => (props.size === 'sm' || props.size === 'md' ? 'fit-content' : '100%')};
    color: ${(props) => (props.variant === 'contained' ? props.color : props.backgroundColor)};
    border-radius: ${(props) => props.borderRadius}px;
    background-color: ${(props) => (props.variant === 'contained' ? props.backgroundColor : props.theme.color.white)};
    border: ${(props) =>
        props.variant === 'outlined' ? '2px solid ' + props.backgroundColor : '2px solid ' + props.backgroundColor};
    box-sizing: border-box;
    transition: color 0.4s, background-color 0.4s, border 0.4s;
    text-decoration: none;
    ${({ size }) =>
        size === 'sm' &&
        `
        padding: 4px 8px;
    `}
    ${({ size }) =>
        size === 'md' &&
        `
        width: fit-content;
        margin: auto;
        padding: 10px 20px;
    `}
    ${({ size }) =>
        size === 'lg' &&
        `
        width: 100%;
        padding: 10px 20px;
    `}
    &:hover {
        background-color: ${(props) =>
            props.variant === 'contained'
                ? colorTransparency(props.backgroundColor ?? '', 80)
                : props.theme.color.white};
    }
`;

const CSSHref = styled.a<CSSButtonProps>`
    ${CSSStyle};
    :hover {
        color: ${(props) => (props.variant === 'contained' ? props.color : props.backgroundColor)};
        text-decoration: none;
    }
`;

export const JRCWidgetButton = ({
    text,
    buttonSize,
    color,
    borderRadius,
    variant,
    backgroundColor,
    url,
    target,
}: WidgetButtonProps) => {
    const intl = useIntl();
    return (
        <CSSHref
            href={url}
            target={target ?? '_blank'}
            size={buttonSize}
            color={color}
            borderRadius={borderRadius}
            variant={variant}
            backgroundColor={backgroundColor}>
            {text && text.length ? text : intl.formatMessage({ id: 'WIDGET_Button_Empty_Text' })}
        </CSSHref>
    );
};
